import { z } from 'zod';
/**
 * Projekt-Versionierung (Plan §22, Issues #63/#64).
 *
 * Eine Version ist ein unveränderlicher Snapshot eines Projekts zu einem
 * bestimmten Zeitpunkt — entweder automatisch beim Abschluss (status →
 * completed) oder explizit über "Neue Version anlegen" (Re-Vision-Schleife
 * bei bereits abgeschlossenen Projekten).
 */
export const createVersionRequest = z
    .object({
    label: z.string().max(80).optional(),
    reason: z.string().min(1).max(500),
    reopenForRevision: z.boolean().default(false),
})
    .strict();
